import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const footerLinks = {
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Services', href: '/services' },
    // { name: 'Portfolio', href: '/portfolio' },
    { name: 'Process', href: '/process' },
  ],
  resources: [
    { name: 'Blog', href: '/blog' },
    // { name: 'Testimonials', href: '/testimonials' },
    { name: 'FAQ', href: '/faq' },
    // { name: 'Pricing', href: '/pricing' },
  ],
  contact: [
    { icon: Mail, text: 'indrajeet1webdev@gmail.com', href: 'mailto:indrajeet1webdev@gmail.com' },
    { icon: Phone, text: '7635005512', href: 'tel:7635005512' },
    { icon: MapPin, text: 'Rajdhanwar, Giridih, Jharkhand', href: '#' },
  ],
};

const socialLinks = [
  { icon: Facebook, href: '#', label: 'Facebook' },
  { icon: Twitter, href: '#', label: 'Twitter' },
  { icon: Linkedin, href: '#', label: 'LinkedIn' },
  { icon: Instagram, href: '#', label: 'Instagram' },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-[#030711]">
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="mb-8">
            <div className="bg-white/95 px-5 rounded-xl inline-block">
              <img
                src={`${process.env.PUBLIC_URL}/futurePathlogo.png`}
                alt="FuturePath Technologies"
                className="h-12 w-auto object-contain"
                style={{ maxWidth: '220px' }}
              />
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed mb-6">
              Transforming businesses with cutting-edge digital solutions. We build software that shapes tomorrow.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  data-testid={`social-${social.label.toLowerCase()}`}
                  className="w-10 h-10 rounded-full glass-card flex items-center justify-center hover:border-primary transition-colors"
                >
                  <social.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white font-outfit font-semibold text-lg mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    data-testid={`footer-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-muted-foreground hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-outfit font-semibold text-lg mb-6">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.href}
                    data-testid={`footer-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="text-muted-foreground hover:text-primary transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-outfit font-semibold text-lg mb-6">Contact</h3>
            <ul className="space-y-4">
              {footerLinks.contact.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    data-testid={`footer-contact-${index}`}
                    className="flex items-start gap-3 text-muted-foreground hover:text-primary transition-colors text-sm group"
                  >
                    <item.icon size={18} className="mt-0.5 group-hover:text-primary" />
                    <span>{item.text}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-muted-foreground text-sm">
            © {new Date().getFullYear()} FuturePath Technologies. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors text-sm">
              Privacy Policy
            </Link>
            <Link to="/service-terms" className="text-muted-foreground hover:text-primary transition-colors text-sm">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
